import DataAndReportingPage from "./DataAndReportingPage";

export default DataAndReportingPage;
